'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _hudlBase = require('hudl-base');

var _triggerDownload = require('hudl-react-kickoff/legacy/utility/trigger-download');

var _triggerDownload2 = _interopRequireDefault(_triggerDownload);

var _feedContentType = require('../../shared/feed-content-type');

var _feedContentType2 = _interopRequireDefault(_feedContentType);

var _propTypes = require('../../shared/prop-types');

var _reactWaypoint = require('react-waypoint');

var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);

var _HighlightFeedItem = require('./HighlightFeedItem');

var _HighlightFeedItem2 = _interopRequireDefault(_HighlightFeedItem);

var _HudlLinkFeedItem = require('./HudlLinkFeedItem');

var _HudlLinkFeedItem2 = _interopRequireDefault(_HudlLinkFeedItem);

var _ImageFeedItem = require('./ImageFeedItem');

var _ImageFeedItem2 = _interopRequireDefault(_ImageFeedItem);

var _MessageFeedItem = require('./MessageFeedItem');

var _MessageFeedItem2 = _interopRequireDefault(_MessageFeedItem);

var _TextFeedItem = require('./TextFeedItem');

var _TextFeedItem2 = _interopRequireDefault(_TextFeedItem);

var _VideoFeedItem = require('./VideoFeedItem');

var _VideoFeedItem2 = _interopRequireDefault(_VideoFeedItem);

var _ReactionsList = require('../Reactions/ReactionsList');

var _ReactionsList2 = _interopRequireDefault(_ReactionsList);

var _AddReaction = require('../Reactions/AddReaction');

var _AddReaction2 = _interopRequireDefault(_AddReaction);

var _ShareButton = require('../Sharing/ShareButton');

var _ShareButton2 = _interopRequireDefault(_ShareButton);

var _ShareFeedItemContainer = require('../Sharing/ShareDialog/ShareFeedItemContainer');

var _ShareFeedItemContainer2 = _interopRequireDefault(_ShareFeedItemContainer);

var _Theatre = require('../Theatre');

var _Theatre2 = _interopRequireDefault(_Theatre);

var _Tags = require('../Tags');

var _Tags2 = _interopRequireDefault(_Tags);

var _pagescrollHelper = require('../../utils/pagescroll-helper');

var _loggingUtil = require('../../utils/logging-util');

var _actionCreators = require('../../store/actions/action-creators');

var _communityContentPlayers = require('../../shared/logging/community-content-players');

var _communityContentPlayers2 = _interopRequireDefault(_communityContentPlayers);

var _services = require('../../utils/services');

var _services2 = _interopRequireDefault(_services);

var _adTrackingUtil = require('../../utils/ad-tracking-util');

var _adTrackingUtil2 = _interopRequireDefault(_adTrackingUtil);

var _logValues = require('../../shared/logging/log-values');

var _constants = require('../../shared/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConnectedFeedItem = function (_PureComponent) {
  _inherits(ConnectedFeedItem, _PureComponent);

  function ConnectedFeedItem(props) {
    _classCallCheck(this, ConnectedFeedItem);

    var _this = _possibleConstructorReturn(this, (ConnectedFeedItem.__proto__ || Object.getPrototypeOf(ConnectedFeedItem)).call(this, props));

    _this.onProfileClick = function (feedUserId) {
      var logData = _this.state.logData;
      new _hudlBase.UsageLogEvent({
        logger: 'Feed',
        data: {
          'FeedUser': feedUserId.type + '-' + feedUserId.relatedId,
          'Func': 'Click',
          'Op': 'Profile',
          'Origin': logData[_logValues.ORIGIN_KEY] || 'Feed',
          'Team': _this.props.currentTeamId,
          'User': logData.currentUserId
        }
      }).log();

      if (_this.props.miniProfileEnabled) {
        _this.props.showMiniProfile(feedUserId.type, feedUserId.relatedId);
      }
    };

    _this.onVideoOverlayClick = function () {
      if (_this.props.openTheatre) {
        _this.props.openTheatre(_this.props.feedContentId, _this.props.showingMiniProfile);
      }
    };

    _this.onFeedLinkClick = function () {
      var feedContentId = _this.props.feedContentId;

      if (!feedContentId) {
        return;
      }

      _services2.default.logFeedContentClick(_this.state.logData);
    };

    _this.onScrollIntoView = function () {
      var communityContentId = _this.getCommunityContentId();
      if (!communityContentId) {
        return;
      }

      _this.props.communityContentEnterView(communityContentId, 'Feed', _this.state.logData);
    };

    _this.onScrollOutOfView = function () {
      var communityContentId = _this.getCommunityContentId();
      if (!communityContentId) {
        return;
      }

      _this.props.communityContentLeaveView(communityContentId, 'Feed', _this.state.logData);
    };

    _this.onShareContent = function (notification, title, showHighlightCta) {
      _this.props.shareContent(_this.props.feedContentId, _this.props.showingMiniProfile, notification, title, showHighlightCta);
    };

    _this.onShareClick = function () {
      _this.props.shareContent(_this.props.feedContentId, _this.props.showingMiniProfile);
    };

    _this.onCloseShare = function () {
      _this.props.shareContent(null);
      if (!_this.props.showingMiniProfile) {
        (0, _pagescrollHelper.enablePageScroll)();
      }
    };

    _this.openMiniProfile = function (feedUserId) {
      // Used for tags, where we always want to use the mini profile
      _this.props.showMiniProfile(feedUserId.type, feedUserId.relatedId);
    };

    _this.shouldLogInitialTheatrePlay = true;
    _this.defaultLogData = {
      app: _logValues.WEB_APP,
      adTrackingId: _adTrackingUtil2.default.getAdTrackingIdAndSetCookie(),
      player: _communityContentPlayers2.default.TimelineCard
    };
    _this.state = {
      logData: _this.createLogData({}, props)
    };
    return _this;
  }

  _createClass(ConnectedFeedItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          content = _props.content,
          feedContentId = _props.feedContentId;

      if (!content) {
        this.props.fetchFeedItemIfNeeded(feedContentId);
      }
      this.props.fetchCurrentUserDetailsIfNeeded();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        logData: this.createLogData(this.state.logData, nextProps)
      });
    }
  }, {
    key: 'createLogData',
    value: function createLogData(currentLogData, newProps) {
      if (newProps.feedContentId) {
        this.defaultLogData[_logValues.FEED_CONTENT_ID_KEY] = newProps.feedContentId;

        // Both these are used for some reason.
        this.defaultLogData.contentId = newProps.feedContentId;
      }
      if (newProps.currentUserId) {
        this.defaultLogData.currentUserId = newProps.currentUserId;
      }

      this.defaultLogData.position = newProps.position;
      this.defaultLogData.videoHasTags = !!newProps.aggregateUserTagCount;
      this.defaultLogData.communityContentId = this.props.content && this.props.content.communityContentId || null;
      return (0, _loggingUtil.copyLogData)(currentLogData, newProps.logData, this.defaultLogData);
    }
  }, {
    key: 'getAuthor',
    value: function getAuthor() {
      var content = this.props.content;
      var authorId = content.authorId && content.authorId.relatedId || content.ownerId && content.ownerId.relatedId;
      if (!authorId) return null;

      var author = this.props.feedUsers.find(function (user) {
        return user.feedUserId.relatedId === authorId;
      });

      return author;
    }
  }, {
    key: 'getCommunityContentId',
    value: function getCommunityContentId() {
      return this.props.content && this.props.content.communityContentId;
    }
  }, {
    key: 'onAttachmentClick',
    value: function onAttachmentClick(attachmentId) {
      (0, _triggerDownload2.default)(attachmentId);
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.content) return null;

      var author = this.getAuthor();
      var reactions = void 0;
      var addReactionButton = void 0;
      var shareButton = void 0;
      var tags = void 0;

      var hasContent = this.props.content && this.props.content.communityContentId;
      var isLoggedIn = this.props.currentUserId && this.props.currentUserId !== _constants.ANONYMOUS_USER_ID;

      if (hasContent) {
        if (isLoggedIn) {
          reactions = _react2.default.createElement(_ReactionsList2.default, {
            communityContentIdObject: this.props.content.communityContentId,
            logData: this.state.logData,
            store: this.context.store });

          addReactionButton = _react2.default.createElement(_AddReaction2.default, {
            communityContentIdObject: this.props.content.communityContentId,
            isBlock: true,
            logData: this.state.logData,
            store: this.context.store });
        }

        shareButton = _react2.default.createElement(_ShareButton2.default, { onClick: this.onShareClick, style: 'minimal', isBlock: true });

        tags = _react2.default.createElement(_Tags2.default, {
          communityContentIdObject: this.props.content.communityContentId,
          store: this.context.store,
          feedContentId: this.props.feedContentId,
          logData: this.state.logData,
          openMiniProfile: this.openMiniProfile
          // We want to make sure that we allow explicit mini profile behavior while also
          // maintaining behavior of opening a mini profile if we are currently showing one
          , miniProfileEnabled: this.props.miniProfileEnabled || this.props.showingMiniProfile });
      }

      var feedCard = void 0;
      switch (this.props.content.type) {
        case _feedContentType2.default.HudlLink:
          feedCard = _react2.default.createElement(_HudlLinkFeedItem2.default, _extends({}, this.props, {
            author: author,
            onFeedLinkClick: this.onFeedLinkClick,
            onProfileClick: this.onProfileClick,
            reactionComponent: reactions,
            tagsComponent: tags
          }));
          break;
        case _feedContentType2.default.HudlMessage:
          feedCard = _react2.default.createElement(_MessageFeedItem2.default, _extends({}, this.props, {
            author: author,
            onAttachmentClick: this.onAttachmentClick,
            onProfileClick: this.onProfileClick,
            reactionComponent: reactions,
            addReactionButton: addReactionButton,
            tagsComponent: tags,
            logData: this.state.logData
          }));
          break;
        case _feedContentType2.default.Image:
          feedCard = _react2.default.createElement(_ImageFeedItem2.default, _extends({}, this.props, {
            author: author,
            onFeedLinkClick: this.onFeedLinkClick,
            onProfileClick: this.onProfileClick,
            reactionComponent: reactions,
            addReactionButton: addReactionButton,
            tagsComponent: tags,
            logData: this.state.logData
          }));
          break;
        case _feedContentType2.default.SharedHighlight:
          feedCard = _react2.default.createElement(_HighlightFeedItem2.default, _extends({}, this.props, {
            addReactionButton: addReactionButton,
            author: author,
            highlightEditorIdentityData: this.props.highlightEditorIdentityData,
            logData: this.state.logData,
            onFeedLinkClick: this.onFeedLinkClick,
            onProfileClick: this.onProfileClick,
            onVideoOverlayClick: this.onVideoOverlayClick,
            onShareContent: this.onShareContent.bind(this),
            reactionComponent: reactions,
            shareButton: shareButton,
            tagsComponent: tags
          }));
          break;
        case _feedContentType2.default.Text:
          feedCard = _react2.default.createElement(_TextFeedItem2.default, _extends({}, this.props, {
            author: author,
            onFeedLinkClick: this.onFeedLinkClick,
            onProfileClick: this.onProfileClick,
            reactionComponent: reactions,
            addReactionButton: addReactionButton,
            logData: this.state.logData
          }));
          break;
        case _feedContentType2.default.Video:
          feedCard = _react2.default.createElement(_VideoFeedItem2.default, _extends({}, this.props, {
            author: author,
            addReactionButton: addReactionButton,
            logData: this.state.logData,
            onFeedLinkClick: this.onFeedLinkClick,
            onProfileClick: this.onProfileClick,
            onVideoOverlayClick: this.onVideoOverlayClick,
            reactionComponent: reactions,
            shareButton: shareButton,
            tagsComponent: tags
          }));
          break;
        default:
          feedCard = null;
          break;
      }

      return _react2.default.createElement(
        'div',
        null,
        feedCard && _react2.default.createElement(_reactWaypoint2.default, {
          onEnter: this.onScrollIntoView,
          onLeave: this.onScrollOutOfView,
          scrollableAncestor: this.props.waypointScrollableAncestor })
        // If no ancestor is specified, the waypoint will find the nearest div that supports scroll tracking
        ,
        feedCard,
        this.props.showSharing && _react2.default.createElement(_ShareFeedItemContainer2.default, {
          onClose: this.onCloseShare,
          feedContentId: this.props.feedContentId,
          communityContentId: this.props.content ? this.props.content.communityContentId : {},
          logData: this.state.logData }),
        this.props.showTheatre && _react2.default.createElement(_Theatre2.default, {
          logData: this.state.logData,
          adTag: this.props.adTag })
      );
    }
  }]);

  return ConnectedFeedItem;
}(_react.PureComponent);

ConnectedFeedItem.propTypes = {
  adTag: _propTypes.adTagShape,
  aggregateUserTagCount: _react.PropTypes.number,
  canDismiss: _react.PropTypes.bool,
  content: _react.PropTypes.shape({
    authorId: _propTypes.FeedUserId.isRequired,
    communityContentId: _propTypes.CommunityContentId,
    ownerId: _propTypes.FeedUserId.isRequired,
    type: _react.PropTypes.oneOf(Object.keys(_feedContentType2.default).map(function (key) {
      return _feedContentType2.default[key];
    })).isRequired
  }),
  currentTeamId: _react.PropTypes.string,
  currentUserId: _react.PropTypes.string,
  feedContentId: _react.PropTypes.string.isRequired,
  feedUsers: _react.PropTypes.arrayOf(_propTypes.FeedUser),
  fetchCurrentUserDetailsIfNeeded: _react.PropTypes.func.isRequired,
  fetchFeedItemIfNeeded: _react.PropTypes.func.isRequired,
  hideFollowButton: _react.PropTypes.bool,
  highlightEditorIdentityData: _react.PropTypes.shape({
    userId: _react.PropTypes.string,
    teamId: _react.PropTypes.string,
    isAthlete: _react.PropTypes.bool,
    isCoach: _react.PropTypes.bool,
    sport: _react.PropTypes.string
  }),
  showSharing: _react.PropTypes.bool,
  showTheatre: _react.PropTypes.bool,
  miniProfileEnabled: _react.PropTypes.bool,
  onDismissFeedItem: _react.PropTypes.func,
  openTheatre: _react.PropTypes.func,
  position: _react.PropTypes.number,
  profileLinkEnabled: _react.PropTypes.bool,
  shareContent: _react.PropTypes.func.isRequired,
  showingMiniProfile: _react.PropTypes.bool,
  showMiniProfile: _react.PropTypes.func.isRequired,
  timelineUserId: _propTypes.FeedUserId,
  waypointScrollableAncestor: _react.PropTypes.any,
  communityContentEnterView: _react.PropTypes.func,
  communityContentLeaveView: _react.PropTypes.func,
  isSponsored: _react.PropTypes.bool
};
ConnectedFeedItem.contextTypes = {
  store: _propTypes.StoreShape
};


function mapStateToProps(state, ownProps) {
  var feedContentId = ownProps.feedContentId;
  var feedItem = state.feedItems && state.feedItems[feedContentId] || {};
  var authorId = feedItem.content && feedItem.content.authorId;
  var feedUserKey = authorId && authorId.type + '-' + authorId.relatedId;
  var isSponsored = feedItem.isSponsored;

  var currentUserId = void 0;
  if (state.userDetails && state.userDetails.currentUser && state.userDetails.currentUser.details) {
    currentUserId = state.userDetails.currentUser.details.userId;
  }

  var position = ownProps.position || 0;
  if (feedUserKey && state.userTimeline) {
    var items = state.userTimeline && state.userTimeline[feedUserKey] && state.userTimeline[feedUserKey].feedItems || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i] === feedContentId) {
        position = i;
      }
    }
  }

  var showSharing = state.sharing.feedContentId && state.sharing.feedContentId === feedContentId && state.sharing.isMiniProfile === ownProps.showingMiniProfile;
  var showTheatre = state.theatre.feedContentId && state.theatre.feedContentId === feedContentId && state.theatre.isMiniProfile === ownProps.showingMiniProfile;

  return _extends({}, feedItem, {
    currentTeamId: state.userDetails.teamId,
    currentUserId: currentUserId,
    position: position,
    showSharing: showSharing,
    showTheatre: showTheatre,
    isSponsored: isSponsored
  });
}

var mapDispatchToProps = {
  fetchFeedItemIfNeeded: _actionCreators.fetchFeedItemIfNeeded,
  fetchCurrentUserDetailsIfNeeded: _actionCreators.fetchCurrentUserDetailsIfNeeded,
  shareContent: _actionCreators.shareContent,
  showMiniProfile: _actionCreators.showMiniProfile,
  openTheatre: _actionCreators.openTheatre,
  communityContentEnterView: _actionCreators.communityContentEnterView,
  communityContentLeaveView: _actionCreators.communityContentLeaveView
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConnectedFeedItem);